import React, { useState } from "react";
import * as Type from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Type";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/lexus/Popover";
import * as Button from "../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { useBnbSelector } from "../../../../redux/store";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as PacksView from "./styles/Packs";
import Pack from "./Pack";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { trackExtrasShow } from "../../../../utils/tracking";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import CarDataConsolidator from "../../../../../../shared-logic/utils/classes/CarDataConsolidator";
import type { ExtraType } from "../../../../../../../common-deprecated/types/CommonTypes";

type PropsType = {
    extra?: ExtraType; // When provided only packs are shown which include this extra. The header is also hidden
};
const Packs = (props: PropsType): JSX.Element | null => {
    const { extra } = props;

    const wltpPopupText = useBnbOptionalLabel("T1.disclaimerWltpShort");
    const items = useBnbSelector((state) => state.items);

    const packs = extra ? CarDataConsolidator.findPackEquipment(extra, items.packs)?.packs || [] : items.packs;

    const [showAllPacks, setShowAllPacks] = useState<boolean>(false);
    const maxPacks = 3;

    if (packs.length < 1) return null;

    return (
        <>
            {!extra && (
                <PacksView.Header>
                    <Flex.Col width={{ sm: 7 / 12, md: 1 }}>
                        <Type.H3 headingType="epsilon" color="midnight" mb={3}>
                            <BnbLabel label="packsRecommended" />
                            {!!wltpPopupText && <Popover showOnClick content={wltpPopupText} useHTML />}
                        </Type.H3>
                    </Flex.Col>
                </PacksView.Header>
            )}
            {packs.slice(0, showAllPacks ? packs.length : maxPacks).map((pack, index) => (
                <Pack packIndex={index} pack={pack} key={pack.id} showImage={index < 3} />
            ))}

            {!showAllPacks && packs.length > maxPacks && (
                <Flex.Row mt={1} mb={2}>
                    <Flex.Col width={1} display="flex" justifyContent="center">
                        <Button.ViewMore
                            width={{ _: "100%", md: "auto" }}
                            onClick={() => {
                                setShowAllPacks(true);
                                trackExtrasShow(NavStep.Customize, "show-all-extra-packs");
                            }}
                        >
                            <BnbLabel label="showAllPacks" />
                            <IconWrapper ml={1} color="azure">
                                <Icon variant="chevronDown" />
                            </IconWrapper>
                        </Button.ViewMore>
                    </Flex.Col>
                </Flex.Row>
            )}
        </>
    );
};

export default Packs;
